import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["success"]

  async connect() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");
    if (!sessionId) return;
  
    const response = await fetch(`/submissions/checkout?session_id=${sessionId}`);
    const session = await response.json();

    if (session.status == "open") {
      window.location.replace("/submissions/pay-and-submit/pay");
    } else if (session.status == "complete") {
      this.successTarget.classList.remove("hidden");
    }
  }
}